// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/style/base.css
// module id = 260
// module chunks = 153